// Ostatni błąd serwera poczty firmy (GET /api/email-settings, `last_error_code`, migracja 065).
//
// Rodzaje, przy których serwer firmy na pewno nie dostał treści maila, więc serwer wysłał go
// zapasowo z adresu the.rENT z nazwą wypożyczalni. LUSTRO Login/backend/lib/transportFirmy.js
// (RODZAJE_Z_ZAPASEM); zgodność pilnuje Login/backend/tests/smtpFirmyBlad.test.js. Przy innych
// rodzajach (zerwane połączenie, brak odpowiedzi) serwer firmy mógł mail przyjąć, więc nie było
// drugiej wysyłki.
export const RODZAJE_Z_ZAPASEM = ['auth', 'dns', 'connect', 'tls', 'sender'];

export const wyslanoZapasowo = (rodzaj) => RODZAJE_Z_ZAPASEM.includes(rodzaj);
